import { Button, Group } from '@mantine/core';
import { useState } from 'react';
import BundleExportModal from './BundleExportModal';
import BundleImportModal from './BundleImportModal';

// The header actions: no ids scopes the export to every instance of the domain. A per-row export
// opens the same BundleExportModal from ConnectorsListScreen instead, scoped to that one row.
const BundleActions = ({ apiBase, accountId, domainId, onChanged }) => {
  const [exportOpen, setExportOpen] = useState(false);
  const [importOpen, setImportOpen] = useState(false);

  return (
    <Group gap="xs">
      <Button variant="default" onClick={() => setExportOpen(true)}>
        Export bundle
      </Button>
      <Button variant="default" onClick={() => setImportOpen(true)}>
        Import bundle
      </Button>

      <BundleExportModal opened={exportOpen} onClose={() => setExportOpen(false)} apiBase={apiBase} />

      <BundleImportModal
        opened={importOpen}
        onClose={() => {
          setImportOpen(false);
          onChanged();
        }}
        apiBase={apiBase}
        accountId={accountId}
        domainId={domainId}
      />
    </Group>
  );
};

export default BundleActions;
